import { render, staticRenderFns } from "./MainNavBar.vue?vue&type=template&id=571bec55&scoped=true"
import script from "./MainNavBar.vue?vue&type=script&lang=js"
export * from "./MainNavBar.vue?vue&type=script&lang=js"
import style0 from "./MainNavBar.vue?vue&type=style&index=0&id=571bec55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.36.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bec55",
  null
  
)

export default component.exports